import Swiper from 'swiper';
import { Navigation, Thumbs, EffectFade } from 'swiper/modules';
import 'swiper/scss';
import 'swiper/scss/effect-fade'; // Импорт стилей для эффекта "fade"

export default function (element, data) {
    const swiperContainer = element.querySelector('.swiper-logos');
    const swiperWrapper = swiperContainer.querySelector('.swiper-wrapper');
    const slides = swiperContainer.querySelectorAll('.swiper-slide');
    const nextBtn = element.querySelector(".swiper-button-next");
    const prevBtn = element.querySelector(".swiper-button-prev");

    const swiperContainerText = element.querySelector('.swiper-preview');
    const swiperWrapperText = swiperContainerText.querySelector('.swiper-wrapper');
    const slidesText = swiperContainerText.querySelectorAll('.swiper-slide');

    var swiper = new Swiper(".swiper-preview", {
        modules: [EffectFade],
        loop: false,
        effect: 'fade',
        autoHeight: true,
        slidesPerView: 1,
        allowTouchMove: false,
        fadeEffect: {
            crossFade: true,
        },
    });
    var swiper2Options = {
        modules: [Navigation, Thumbs],
        loop: true,
        slidesPerView: 'auto',
        spaceBetween: 0,
        slideToClickedSlide: true,
        centeredSlides: true,
        navigation: {
            nextEl: nextBtn,
            prevEl: prevBtn,
        },
        thumbs: {
            swiper: swiper,
        },
        breakpoints: {
            992: {
                slidesPerView: 5,
            },
            560: {
                slidesPerView: 3,
            },
        }
    };

    if (slides.length > 1 && slides.length < 11) {
        slides.forEach(slide => {
            const cloneSlide = slide.cloneNode(true);
            swiperWrapper.appendChild(cloneSlide);
        });
        slidesText.forEach(slide => {
            const cloneSlide = slide.cloneNode(true);
            swiperWrapperText.appendChild(cloneSlide);
        });
    }

    if (slides.length > 1 && nextBtn && prevBtn) {
        nextBtn.style.display = 'flex';
        prevBtn.style.display = 'flex';
    } else if (nextBtn && prevBtn) {
        nextBtn.style.display = 'none';
        prevBtn.style.display = 'none';
    }
    
    element.swiper = new Swiper(".swiper-logos", swiper2Options);

    let portfolioSliders = document.querySelectorAll('.factories__portfolio .slider__block');
    
    setTimeout(() => {
        portfolioSliders.forEach(portfolioSlider => {
            if(!portfolioSlider.classList.contains('visible')) {
                portfolioSlider.classList.add('hidden');
            }
        });
    }, 100);

    element.swiper.on('slideChange', function () {
        let activeSlide = element.swiper.slides[element.swiper.activeIndex];
        let dataId = activeSlide.getAttribute('data-id');

        portfolioSliders.forEach(portfolioSlider => {
            if (portfolioSlider.getAttribute('data-id') == dataId) {
                portfolioSlider.classList.remove('hidden');
            } else {
                portfolioSlider.classList.add('hidden');
            }
        });
    });
};